<template>
  <div id="app">
    <template v-if="!$store.state.isEnhanced">
      <header-area></header-area>
      <div class="container">
        <!--Non-Mobile Only-->
        <header-events-block v-if="$route.name==='Home'"></header-events-block>
        <header-breadcrumbs v-else class="hidden-sm-down"></header-breadcrumbs>
        <sort-bar v-if="sortBar" :sortBar="sortBar"></sort-bar>
        <search-filter v-if="$route.meta.filterIsAvailable"></search-filter>
        <!--Non-Mobile Only-->
        <div class="row">
          <div class="col-12" :class="!isArticlePage() ? 'col-md-8': 'col-md-12'">
            <router-view></router-view>
          </div>
          <div v-if="!isArticlePage()" class="col-md-4 col-12 hidden-sm-down">
            <sidebar></sidebar>
          </div>
        </div>
      </div>
      <footer-area></footer-area>
      <order-reprint-modal></order-reprint-modal>
    </template>
    <template v-else>
      <enhanced-view></enhanced-view>
    </template>
  </div>

</template>

<script>
import HeaderArea from '@/components/main-layout/header-area/HeaderAreaComponent'
import Sidebar from '@/components/main-layout/sidebar/SidebarComponent'
import SortBar from '@/components/main-layout/shared/SortBarComponent'
import FooterArea from '@/components/main-layout/footer-area/FooterAreaComponent'
import HeaderBreadcrumbs from '@/components/main-layout/header-area/HeaderBreadcrumbsComponent'
import HeaderEventsBlock from '@/components/main-layout/header-area/HeaderEventsBlockComponent'
import SearchFilter from '@/components/search-results/SearchFilterComponent'
import OrderReprintModal from '@/components/shared/OrderReprintComponent'
import EnhancedView from '@/components/shared/EnhancedViewComponent'

export default {
  components: {
    HeaderArea,
    HeaderBreadcrumbs,
    HeaderEventsBlock,
    SearchFilter,
    SortBar,
    Sidebar,
    FooterArea,
    OrderReprintModal,
    EnhancedView
  },
  data () {
    return {
      sortBar: false,
      faviconPath: 'img/' + process.env.SITE + '/favicon.ico',
      title: 'Impact Journals - ' + process.env.SITE_NAME
    }
  },
  methods: {
    insertFavicon () {
      let src = require('./assets/' + this.faviconPath)
      document.head || (document.head = document.getElementsByTagName('head')[0])
      var link = document.createElement('link')
      link.id = 'dynamic-favicon'
      link.rel = 'shortcut icon'
      link.href = src
      document.head.appendChild(link)
    },
    insertTitle () {
      document.title = this.title
    },
    isArticlePage () {
      return this.$route.matched[0].name === 'article-page'
    }
  },
  created () {
    this.insertFavicon()
    this.insertTitle()
  },
  name: 'app'
}
</script>

<style scoped lang="scss">
  .container {
    background-color: $white;
    padding: 0px 30px;
  }
</style>

<style lang="scss">
  .container {
     @media (min-width: $breakpoint-md) {
      width: 990px !important;
    }
    @media (min-width: $breakpoint-xl) {
      width: 1220px !important;
    }
  }
</style>




// WEBPACK FOOTER //
// App.vue?f7038634